module.exports = __webpack_public_path__ + "img/mi-campaign.51b6057e.svg";